<script>
import './stylesheets/components/VsModal';

import $ from 'domtastic';

import eventHub from './eventHub';
import LazyLoad from './LazyLoad';

export default {
  props: {
    title: String,
    showBorder: [String, Boolean],
    preventDismiss: [String, Boolean],
    fullBody: [String, Boolean],
  },
  directives: {
    LazyLoad,
  },
  data: () => ({
    previousFocus: null,
  }),
  computed: {
    hasFooter() {
      return !!this.$slots.footer;
    },
    focusableElements() {
      return this.$el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    },
    lastElement() {
      return this.focusableElements[this.focusableElements.length - 1]
    },
    firstElement() {
      return this.focusableElements[0];
    },
  },
  created() {
    eventHub.$on('esc-pressed', this.close);
    eventHub.$on('lazy-load', this.handleLazyLoad);
  },
  mounted() {
    this.previousFocus = document.activeElement;

    if (!this.preventDismiss) {
      this.$el.querySelector('.modal__close').focus();
    } else {
      $(this.firstElement).on('keydown', this.focusLastElement);
    }

    $(this.lastElement).on('keydown', this.focusFirstElement);
  },
  updated() {
    if (this.preventDismiss) {
      $(this.firstElement).off('keydown', this.focusLastElement);
      $(this.firstElement).on('keydown', this.focusLastElement);
    }

    if (this.lastElement) {
      $(this.lastElement).off('keydown', this.focusFirstElement);
      $(this.lastElement).on('keydown', this.focusFirstElement);
    }
  },
  beforeDestroy() {
    this.$_focusPreviousElement();
    eventHub.$off('esc-pressed', this.close);
    eventHub.$off('lazy-load', this.handleLazyLoad);
    if (this.lastElement) $(this.lastElement).off('keydown', this.focusFirstElement);
    if (this.preventDismiss) $(this.firstElement).off('keydown', this.focusLastElement);
  },
  methods: {
    $_focusPreviousElement() {
      if (this.previousFocus) {
        this.previousFocus.focus();
        this.previousFocus = null;
      }
    },
    close() {
      if (!this.preventDismiss) {
        this.$_focusPreviousElement();
        this.$emit('close');
      }
    },
    handleLazyLoad() {
      this.$emit('lazy-load');
    },
    focusFirstElement(e) {
      if (e.keyCode == 9 && !e.shiftKey) {
        e.preventDefault();

        this.firstElement.focus();
      }
    },
    focusLastElement(e) {
      if (e.keyCode == 9 && e.shiftKey) {
        e.preventDefault();

        this.lastElement.focus();
      }
    },
  },
};
</script>

<template lang='pug'>
transition(name='modal-content')
  .modal(role='dialog', aria-modal='true', :aria-label='title')
    .modal__container
      .modal__ui-block(@click='close')
        slot(name='blocker')
      .modal__content.overflow-hidden
        .modal__close(
          v-if='!preventDismiss',
          tabindex='0',
          role='button',
          aria-label='close modal',
          @click='close',
          @keyup.enter='close',
          @keydown.shift.tab.exact='focusLastElement',
        )
          svg(viewBox='0 0 24 24')
            path(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

        .modal__header
          h5.text-4xl.font-bold {{title}}
        .modal__controls
          slot(name='controls')
        .modal__body(
          v-lazy-load='',
          :class='{ "modal__body--border": showBorder, "modal__body--full": fullBody }',
        )
          slot(name='body')
        .modal__footer(v-if='hasFooter')
          slot(name='footer')
</template>